/*import React from 'react';
//import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import SupportAdmin from './SupportAdmin';
import { Switch } from 'react-router-dom';
import ReactDOM from "react-dom";

const path = window.location.pathname
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  

    {path.indexOf('/support') === -1 ? <App /> : <SupportAdmin /> }
    

  

  </React.StrictMode>
)
*/


import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';


import SupportAdmin from './SupportAdmin';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import Kanvaass from './components/Dalle-E/Kanvaass';
import Overlay  from './components/Dalle-E/Overlay';



const path = window.location.pathname

ReactDOM.render(
  <BrowserRouter>
  <React.StrictMode>
  
    { path.indexOf('/support') === -1 ? <App /> : <SupportAdmin /> }
    <Kanvaass/>
  
   
  </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root')

);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


/*
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import SupportAdmin from './SupportAdmin';
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));

const path = window.location.pathname

root.render(
  <BrowserRouter>
  <React.StrictMode>
     { path.indexOf('/support') === -1 ? <App /> : <SupportAdmin /> }
  </React.StrictMode>
  </BrowserRouter>
);

reportWebVitals();
 

*/